import uk from './ua.json';
import en from './en.json';

const localizationKeys: { [key in string]: Record<string, unknown> } = {
  uk,
  en,
};

export default localizationKeys;
